<template>
  <van-button
    :type="type"
    :size="size"
    :native-type="nativeType"
    :disabled="disabled"
    :square="square"
    :round="round"
    :plain="plain"
    @click.stop="$emit('click')"
  >
    <slot />
  </van-button>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'small'
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseButton.vue